import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import PreviewSiteButton from "./components/feature/PreviewSiteButton";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <PreviewSiteButton />
    </BrowserRouter>
  );
}

export default App;
